var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"particles-js",staticStyle:{"position":"fixed","display":"block"}},[_c('vue-particles',{attrs:{"color":"#dedede"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }